var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2384 2.60966L9.61888 1.41245C9.80115 1.38642 9.96995 1.51305 9.99602 1.6953C9.99822 1.71091 9.99935 1.72666 9.99935 1.74244V15.6404C9.99935 15.8245 9.85008 15.9738 9.66602 15.9738C9.65022 15.9738 9.63448 15.9726 9.61888 15.9704L1.2384 14.7732C0.909969 14.7263 0.666016 14.445 0.666016 14.1132V3.26963C0.666016 2.93786 0.909969 2.65658 1.2384 2.60966ZM1.99935 3.84783V13.535L8.66602 14.4874V2.89544L1.99935 3.84783ZM10.666 13.3581H12.666V4.02476H10.666V2.69143H13.3327C13.7009 2.69143 13.9993 2.98991 13.9993 3.3581V14.0248C13.9993 14.393 13.7009 14.6915 13.3327 14.6915H10.666V13.3581ZM6.13268 8.69145L7.99935 11.3581H6.39935L5.33268 9.83432L4.26601 11.3581H2.66602L4.53268 8.69145L2.66602 6.02476H4.26601L5.33268 7.54858L6.39935 6.02476H7.99935L6.13268 8.69145Z",
    fill: "#192839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadingIcon);
export default __webpack_public_path__ + "static/media/leading-icon.6ec36dae47a77a5ea642f3c9563833ec.svg";
export { ForwardRef as ReactComponent };